export default __webpack_public_path__ + "static/media/element_18.5907f1e9.jpg";